import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import Api from './commons/axios.js'
let VueCookie = require('vue-cookie');
Vue.prototype.$api = Api;
Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(VueCookie);

new Vue({
    router,
    store,
  render: h => h(App),
}).$mount('#app');
